module.exports = __webpack_public_path__ + "static/media/ruc_logo.262733aa.svg";